var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLuggage = function SvgLuggage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.798 3h8.294c.551 0 1.003.429 1.003.953v3.211h4.202v-.01c.631 0 1.143.487 1.143 1.087v11.654c0 .6-.512 1.086-1.143 1.086h-4.212v-2.43h1.524c.27 0 .501-.21.501-.476v-1.773a.49.49 0 0 0-.501-.476h-1.524V7.164H15.6v8.671h-2.998c-.27 0-.502.21-.502.477v1.772c0 .258.221.477.502.477v.01H15.6V21H8.27V7.164h7.31V4.696c0-.267-.23-.476-.501-.476H8.81a.49.49 0 0 0-.501.476v2.459H6.795V3.953c0-.524.452-.953 1.003-.953M1.44 19.914V8.25c0-.6.511-1.086 1.143-1.086h4.212V21H2.583c-.632 0-1.143-.486-1.143-1.086"
  })));
};
export default SvgLuggage;